import { createFileRoute } from '@tanstack/react-router';
import { Fragment } from 'react';
import Contacts from '@/components/partials/contacts';
import { t } from '@/lib/i18n';
import { getMainInfo } from '@/lib/server-fns.ts';
import Breadcrumbs from '@/components/layout/breadcrumbs.tsx';
import Section from '@/components/layout/section.tsx';

const { VITE_LOCALE } = import.meta.env;

export const Route = createFileRoute('/contacts')({
	component: ContactsPage,
	loader: () => getMainInfo(),
	head: ({ loaderData }) => ({
		meta: [
			{
				name: 'apple-mobile-web-app-title',
				content: `Jervice - ${t('global.menu.contacts')}`,
			},
			{
				name: 'og:title',
				content: `Jervice - ${t('global.menu.contacts')}`,
			},
			{
				name: 'og:description',
				content: `${loaderData?.contactEmail} • ${loaderData?.contactPhone} • ${loaderData?.contactFullAddress}`,
			},
			{
				name: 'og:url',
				content: `https://jervice.${VITE_LOCALE === 'en' ? 'eu' : 'pl'}/contacts`,
			},
			{
				name: 'og:image',
				content: loaderData?.playerPhotos?.[2]?.url || '/images/main.png',
			},
			{
				name: 'twitter:title',
				content: `Jervice - ${t('global.menu.contacts')}`,
			},
			{
				name: 'twitter:description',
				content: `${loaderData?.contactEmail} • ${loaderData?.contactPhone} • ${loaderData?.contactFullAddress}`,
			},
			{
				name: 'twitter:url',
				content: `https://jervice.${VITE_LOCALE === 'en' ? 'eu' : 'pl'}/contacts`,
			},
			{
				name: 'twitter:image',
				content: loaderData?.playerPhotos?.[2]?.url || '/images/main.png',
			},
			{ title: `Jervice - ${t('global.menu.contacts')}` },
		],
	}),
});

function ContactsPage() {
	return (
		<Fragment>
			<Section className="py-6 max-md:py-4">
				<Breadcrumbs
					items={[
						{ title: t('global.menu.home'), link: '/' },
						{ title: t('global.menu.contacts') },
					]}
				/>
			</Section>

			<Contacts />
		</Fragment>
	);
}
